var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_html.js
// module id = 70
// module chunks = 0